// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","title":"Layout_title__pN8K3","content":"Layout_content__UOgH6"};